import {h, Fragment} from "preact"
import { useFacets } from '@nosto/preact'

import Facet from './Facet'
import RangeFacet from './RangeFacet'
import SidebarSort from './SidebarSort'

export default ({ sidebarOpen, toggleSidebar }) => {
    const { facets } = useFacets();

    return facets?.length > 0 ? (
        <>
            <div
                class="filter-shade"
                aria-label="Close filters list"
                aria-controls="ns-sidebar"
                role="button"
                tabIndex="0"
                onClick={toggleSidebar}
            ></div>
            <aside
                id="ns-sidebar"
                class="filters"
                aria-expanded={sidebarOpen}
                aria-label="Filter options"
            >
                <div class="filters__inner sticky-content-container">
                    {/* HEADER */}
                    <header class="filters__heading">
                        <div class="filters__heading-text heading-font h4">Filters</div>
                        <button
                            class="filters__close"
                            type="button"
                            aria-label="Close filter list"
                            aria-controls="ns-sidebar"
                            onClick={toggleSidebar}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-x" aria-hidden="true" focusable="false" role="presentation">
                                <path d="M18 6 6 18M6 6l12 12"></path>
                            </svg>
                        </button>
                    </header>
                    
                    {/* CONTENT */}
                    <div class="ns-sidebar__body">
                        <ul>
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return (<Facet 
                                                key={facet.field} 
                                                facet={facet} 
                                                sidebarOpen={sidebarOpen}
                                            />)
                                    case "stats":
                                        return (<RangeFacet 
                                                key={facet.field} 
                                                facet={facet} 
                                                sidebarOpen={sidebarOpen}
                                            />)
                                    default:
                                        return null
                                }
                            })}
                            {/* ADD SORT FOR MOBILE */}
                            <SidebarSort 
                                sidebarOpen={sidebarOpen}
                            />
                        </ul>
                    </div>
                </div>
            </aside>
        </>
    ) : ( '' )
}
